import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'base-root',
    templateUrl: './base.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BaseComponent {
  sidenav!: MouseEvent
}
